import React from "react";
import { Link, useLocation, useResolvedPath } from "react-router-dom";
import "../../Stylesheets/Breadcrumbs.css";

const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const pathNameMap = {
  "2d": "2D Data Acquisition and Processing",
  "3d": "3D Data Acquisition and Processing",
  ihds: "DST IHDS-Crowdsourcing ",
  "dst-dp": "DST Digital Poompuhar",
  aicte_rps: "AICTE-RPS Shape Representation",
  vaidya: "VGST V-Vaidya",
  "2DDACS": "2D Data Acquisition / Capture Setup",
  IRE: "Image Restoration and Enhancement",
  LR2D: "Learning Representation of 2D Data",
  FCC2D:
    "Filtering, Classification, and Categorization of 2D Data",
  QAI: "Quality Analysis of Images",
  DLT: "Detection, Localization, and Tracking",
  "3DA": "3D Data Acquisition",
  "3DRR": "3D Reconstruction and Recreation",
  LR3D: "Learning Representation of 3D Data",
  R3D: "Refinement of 3D Data",
  "3DFCC":
    "3D Data Filtering, Classification, and Categorization",
  "3DODT": "3D Object Detection and Tracking",
  sponsored: "Sponsored Research Projects",
  Consultancy: "Consultancy Projects",
};

const mapPathToName = (path) =>
  pathNameMap[path] || capitalizeFirstLetter(path.replace(/_/g, " "));

const Breadcrumbs = () => {
  const location = useLocation();
  const resolvedPath = useResolvedPath(location.pathname);
  const pathSegments = resolvedPath.pathname.split("/").filter(Boolean);

  // Don't render breadcrumbs if there's less than 2 segments
  if (pathSegments.length < 2) {
    return null;
  }

  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        {pathSegments.map((segment, index) => (
          <li
            key={index}
            className={`breadcrumb-item ${
              index === pathSegments.length - 1 ? "active" : ""
            }`}
          >
            {index === pathSegments.length - 1 ? (
              mapPathToName(segment)
            ) : (
              <Link
                to={`/${pathSegments.slice(0, index + 1).join("/")}`}
                className="breadcrumb-link "
              >
                {mapPathToName(segment)}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
